module.exports = __webpack_public_path__ + "img/丁香.9650474d.jpg";